var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-top'),_c('nav-left',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCreatePage),expression:"!isCreatePage"}],style:({zIndex: _vm.isShowAllLeft ? 2001 : 2100}),on:{"showAllLeft":_vm.changeStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }